import splitComponentStyles from '../split-components';
import splitStaticListStyles from './split-static-list';
